'use client'
import { usePathname } from 'next/navigation';

interface DrawerProps {
    isOpen: boolean;
    onClose?: () => void;
    children: React.ReactNode;
}

export const Drawer = ({ isOpen, onClose, children }: DrawerProps) => {
    const pathname = usePathname();
    const isBookPage = pathname?.startsWith('/book/');
    if (!isOpen) return null;
    return (
        <div 
            className={`fixed top-0 right-0 md:w-1/2 w-full h-full open-details  transform transition-transform duration-500 ${
                isOpen ? 'md:translate-x-0 translate-y-0 active' : 'md:translate-x-full translate-y-full'
            }`}>
            {!isBookPage && (
                <button
                        onClick={onClose}
                        onTouchEnd={(e) => {
                            e.stopPropagation();
                            onClose && onClose();
                                            }}
                        className="text-gray-600 hover:text-gray-900 p-2"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M11.7418 6.25105C12.0766 6.58579 12.0766 7.1285 11.7418 7.46323L8.06221 11.1429H17.9929C18.4663 11.1429 18.85 11.5266 18.85 12C18.85 12.4734 18.4663 12.8571 17.9929 12.8571H8.06221L11.7418 16.5368C12.0766 16.8715 12.0766 17.4142 11.7418 17.7489C11.4071 18.0837 10.8644 18.0837 10.5297 17.7489L5.38679 12.6061C5.22605 12.4453 5.13574 12.2273 5.13574 12C5.13574 11.7727 5.22605 11.5547 5.38679 11.3939L10.5297 6.25105C10.8644 5.91632 11.4071 5.91632 11.7418 6.25105Z" fill="currentColor"/>
                        </svg>
                 </button>
            )}
            {children}
        </div>
    );
};
